import { Box, Button, Heading } from '@hover/blueprint';
import { Link as GatsbyLink } from 'gatsby';
import React from 'react';
import TryItOut from '../../components/common/try-it-out';
import PartnerLayout from '../../components/layout';
import Footer from '../../components/layout/footer';
import Advantages from '../../components/order-page/advantages';
import EstimateToOrder from '../../components/order-page/estimateToOrder';
import HappyCustomers from '../../components/order-page/happyCustomers';

const index = () => (
  <PartnerLayout
    navbarBackgroundColor="neutral.100"
    title="Estimate to Order - Beacon 3D+"
  >
    <Box
      minH={{ base: 700, desktop: 800 }}
      px={600}
      py={900}
      textAlign="center"
      bgColor="neutral.100"
      w="100%"
      alignItems="center"
      justifyContent="center"
      mb={{ base: 25, desktop: 84 }}
      flexDir="column"
    >
      <Heading size={{ base: 600, desktop: 700 }} maxW="5xl">
        Manage Your Workflow More Efficiently With Beacon 3D+ And Beacon Pro+
      </Heading>
      <Button size="large" as={GatsbyLink} to="./signup/">
        Start Free Trial
      </Button>
    </Box>

    <Box
      p={{ base: 600, tablet: 400 }}
      maxW={{ desktop: '7xl', base: '5xl' }}
      w="100%"
      mb={1000}
    >
      <EstimateToOrder />
    </Box>

    <Box d="block" bgColor="brandNavy.900" py={1000} w="100%" px={600}>
      <Advantages />
    </Box>

    <HappyCustomers />

    <TryItOut
      title="Start Using Estimate To Order Today"
      body="Sign up for Beacon 3D+ today and give Estimate To Order a try!"
      cta={{ title: 'Start Free Trial', url: './signup/' }}
      my={24}
    />

    <Footer />
  </PartnerLayout>
);

export default index;
